import admin from "./_admin";
import "../../setup/js/_toggleClass";
import "../../setup/js/_scaleRoot.2";
import "../../setup/js/_swiper";
import "../../setup/js/_universalLink";
import "../../setup/js/_scrollwatch";
//import "../../setup/js/_language";
import scrollFrame from "../../setup/js/_scrollFrame.2";
import scrollWatch from "../../setup/js/_scrollWatch.2";
// import "lazysizes";
// import "@fancyapps/fancybox";

window.addEventListener("load", function () {
  var url = new URL(window.location.href);
  var param_admin = url.searchParams.get("admin");
  //admin.init();
  admin.executeFunctions();

  $("#wrapper").scalePlatform();
  $(window).on("resize", function () {
    $("#wrapper").scalePlatform();
  });
  commonLibs();

  $("[data-fancybox]").fancybox({
    infobar: false,
    arrows: false,
    keyboard: false,
    touch: false,
    animationEffect: false,
    transitionEffect: false,
    clickSlide: false,
    clickOutside: false,
    smallBtn: false,
    caption: function (instance, item) {
      // console.log($(this).find('figcaption'));
      // return $(this).find('figcaption').html();
    },
    afterLoad: function (instance, current) {
      let popupClassname = current.opts.fancybox;
      instance.current.$content.addClass(popupClassname + "-content");
      instance.current.$content.append(
        "<span data-fancybox-close title='Close' class='close-fancybox'>Close</span>"
      );
      instance.current.$content
        .parents(".fancybox-container")
        .addClass(popupClassname + "-container");
      instance.current.$content
        .parents(".fancybox-inner")
        .addClass(popupClassname + "-inner");
      instance.current.$content
        .parents(".fancybox-stage")
        .addClass(popupClassname + "-stage");
      instance.current.$content
        .parent(".fancybox-slide")
        .addClass(popupClassname + "-slide");
    },
  });
});

var commonLibs = function () {
  $("#wrapper").scalePlatform();

  $(".onelink").each(function () {
    $(".onelink").universalLink();
  });

  $("#navBurger").each(function () {
    $("#navBurger").toggleClassname({
      toggle: [
        {
          el: $("#floattop"),
          className: "active",
        },
        {
          el: $("#floatnav"),
          className: "active",
        },
        {
          el: $("#navBurger"),
          className: "is-active",
        },
        {
          el: $("#navBurger"),
          className: "active",
        },
      ],
    });
  });

  $("#subwebBurger").each(function () {
    $("#subwebBurger").toggleClassname({
      toggle: [
        {
          el: $(".midbar__menu"),
          className: "active",
        },
        {
          el: $("#subwebBurger"),
          className: "is-active",
        },
      ],
    });
  });

  $("#asideRightToggle").each(function () {
    $(this).toggleClassname({
      toggle: [
        {
          el: $(".floatright__main"),
          className: "active",
        },
        {
          el: $(".floatright .aside"),
          className: "active",
        },
      ],
    });
  });

  $(".scrollTop").each(function () {
    $(this).on("click", function () {
      $("html, body").animate({ scrollTop: 0 }, 400);
    });
  });

  // if ($("[data-lightbox]").length > 0) {
  //     $("[data-lightbox]").each(function () {
  //         $(this).lightBox({
  //             objLightBox: $(this).attr('href'),
  //             type: $(this).data('lightbox-type')
  //         });
  //     });
  // }
};
scrollFrame.init();
scrollWatch.init({
  options: {
    onElementInView: function (e) {
      var $this = $(e.el).parents("[id]");
      var dataBlockId = $this.attr("id");

      //console.log(dataBlockId);
      // $(`.nav-left--item[data-fts-selector='data-block-id="${dataBlockId}"']`);
      $(`[data-fts-selector]`).removeClass("active");
      $(`[data-fts-selector='[id="${dataBlockId}"]']`).addClass("active");
    },
    onElementOutOfView: function (e) {
      var $this = $(e.el).parents("[id]");
      var dataBlockId = $this.attr("id");
      // console.log(dataBlockId);
      $(`[data-fts-selector='[id="${dataBlockId}"]']`).removeClass("active");
    },
  },
});
// setTimeout(function () {
//   $(".btn_autoScroll").trigger("click");
//   console.log("hjhj");
// }, 500);
var target;
var actIframe = "";
$(".btn-openpopup").on("click", function (e) {
  target = $(this).data("target");
  $(target).toggleClass("active");
  $("#popup_content iframe").attr("src", "");
  actIframe = $(this).attr("href");
  if (actIframe == "") {
    return false;
  } else {
    $("#popup_content iframe").attr("src", actIframe);
    return false;
  }
  e.preventDefault();
});
